const MealsData = [
    {
        id: 1,
        img: "/images/breakfast.svg",
        whiteImg: "/images/whiteBreakfast.svg",
        name: "صبحانه",
        label: "BREAKFAST"
    },
    {
        id: 2,
        img: "/images/snack.svg",
        whiteImg: "/images/whiteSnack.svg",
        name: "میان وعده صبح",
        label: "BRUNCH"
    },
    {
        id: 3,
        img: "/images/lunch.svg",
        whiteImg: "/images/whiteLunch.svg",
        name: "ناهار",
        label: "LUNCH"
    },
    {
        id: 4,
        img: "/images/snack.svg",
        whiteImg: "/images/whiteSnack.svg",
        name: "میان وعده ظهر",
        label: "EVENING MEAL"
    },
    {
        id: 5,
        img: "/images/dinner.svg",
        whiteImg: "/images/whiteDinner.svg",
        name: "شام",
        label: "DINNER"
    }
]

export default MealsData